import type { ComponentProps } from 'react'

import { cn } from '@/shared/lib/utils'

export function CatalogCardBody({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="catalog-card-body" className={cn('catalog-card-body', className)} {...props} />
}

export function CatalogCardFooter({
  className,
  inlineAlign = false,
  ...props
}: ComponentProps<'div'> & { inlineAlign?: boolean }) {
  return (
    <div
      data-slot="catalog-card-footer"
      className={cn('catalog-card-footer', inlineAlign && 'catalog-card-footer--inline', className)}
      {...props}
    />
  )
}
